import { render, staticRenderFns } from "./TransactionsHistory.vue?vue&type=template&id=932de652&scoped=true&"
import script from "./TransactionsHistory.vue?vue&type=script&lang=js&"
export * from "./TransactionsHistory.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsHistory.vue?vue&type=style&index=0&id=932de652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932de652",
  null
  
)

export default component.exports